import React from 'react'

const SectionFive = (props) => {
    const {handleButtonClick ,setSelectedOptions ,selectedOptions,toggleOption ,setMessageBoard,setErrorTabEnable ,setmasterResetTab} = props
  return (
    <>
    <div className="error-message-head1">Check the issue status</div>
    <div className="error-message-head2">
      Check if the issue is resolved
    </div>
    <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
      <button
        onClick={() => {
          handleButtonClick(5, "yes");
          setMessageBoard(false);
          setErrorTabEnable(false);
        }}
        className={`error-button ${
          toggleOption[5] === "yes" ? "clicked" : ""
        }`}
        disabled={selectedOptions[5]}
      >
        Yes
      </button>
      <button
        onClick={() => {
          handleButtonClick(5, "no");
          setSelectedOptions([true, true, true, true, true, true, false]);
        }}
        className={`error-button ${
          toggleOption[5] === "no" ? "clicked" : ""
        }`}
        disabled={selectedOptions[5]}
      >
        No
      </button>
    </div>
    <div className="error-message-head2">Perform Master Reset</div>
    <div className="error-message-head2">
      Note - Before initiating Master Reset - Inform subscriber on the loss
      of favourite channels and other settings to default
    </div>
    <div className="error-message-head2">
      Master Reset on SD box will default on Screen Language to Hindi on the
      last screen - subscriber should change to English if required
    </div>

    <div
      onClick={() => {
        setmasterResetTab(true);
        setErrorTabEnable(false);
      }}
      className="error-message-head2"
      style={{
        color: "#005FEC",
        textDecoration: "underline",
        pointerEvents: "cursor",
      }}
    >
      HDPVR Master Reset Procedure
    </div>
    <div className="error-message-head1">Call Logs</div>

    {/* //1 */}
    <table
      style={{
        border: "1px",
        solid: "#ccc",
        borderCollapse: "collapse",
        width: "100%",
        marginTop: "12px",
      }}
    >
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Type</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          New Package
        </td>
      </tr>
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Area</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          Request
        </td>
      </tr>
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Sub Area</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          Modify Packages / Add Channel / Drop Channel / Scenario Specific
        </td>
      </tr>
      <tr className="table-head">
        <td className="call-logs-table">
          <strong>Resolution Code</strong>
        </td>
        <td style={{ fontWeight: "400" }} className="call-logs-table">
          Scenario Specific
        </td>
      </tr>
    </table>
  </>
  )
}

export default SectionFive
